import React from 'react';
import { Img } from 'react-image';
import { ordinalSuffixOf } from 'shared-utils';
import { ContestReward, ContestRewardTypes } from 'types';

const PrizeListTable = ({ rewards }: { rewards: ContestReward[] }) => {
	return (
		<div className="relative p-5 mt-[10px] rounded-[12px] dark:bg-[#1F2A37] border-[0.5px] dark:border-[#c7c9d91a] bg-white isolate">
			<div className="dark:z-[-1] pointer-events-none absolute inset-0 w-full h-full rounded-[12px] [background:_linear-gradient(117.58deg,_rgba(30,_67,_67,_0.16)_-107.79%,_rgba(204,_235,_235,_0)_100%)] dark:[background:linear-gradient(118deg,_rgba(215,_237,_237,_0.16)_-47.79%,_rgba(204,_235,_235,_0.00)_100%)]"></div>
			<div className="space-y-4">
				{rewards?.map(reward => (
					<div
						key={reward?.order}
						className="flex justify-between items-center pb-2 border-b dark:border-[rgba(204,_221,_255,_0.10)] border-[#EBEBF0]"
					>
						<div className="dark:text-[#F2F2F5] text-base font-[500]">
							{reward?.order}
							<sup>{ordinalSuffixOf(reward?.order, false)}</sup>
						</div>
						<div className="flex items-center min-w-[35%] justify-start">
							{reward?.type === ContestRewardTypes.MONEY ? (
								<div className="flex items-center gap-1 text-sm dark:text-[#F2F2F5] font-[500]">
									<Img src="/assets/moneyReward.svg" /> ₹{reward?.reward?.toLocaleString()}
								</div>
							) : (
								<div className="flex items-center gap-1 text-sm dark:text-[#F2F2F5] font-[500]">
									<Img src="/assets/level-up-coins.svg" className="max-h-[16px]" /> {reward?.reward?.toLocaleString()}{' '}
									coins
								</div>
							)}
						</div>
					</div>
				))}
			</div>

			{rewards?.find(reward => reward?.type === ContestRewardTypes.LEVELUP_COINS) ? (
				<div className="mt-4 text-[#555770] dark:text-[#C7C9D9]">
					Use <Img src="/assets/level-up-coins.svg" className="max-h-[16px] inline" /> LevelUp coins to redeem from the
					reward store
				</div>
			) : null}
		</div>
	);
};

export default PrizeListTable;
